var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchemaView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5577_21052)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.625 3H15.9613C16.502 3 17.0205 3.2166 17.4029 3.60215C17.7721 3.97452 17.9851 4.47501 17.9992 5H17.1241C17.1187 4.86461 17.0898 4.73106 17.0388 4.60541C16.9807 4.4625 16.895 4.33266 16.7867 4.22345C16.6784 4.11425 16.5497 4.02785 16.408 3.96929C16.2663 3.91073 16.1144 3.88118 15.9613 3.88235H13.625H6.03875C5.8856 3.88118 5.73375 3.91073 5.59203 3.96929C5.45031 4.02785 5.32156 4.11425 5.21326 4.22345C5.10496 4.33266 5.01928 4.4625 4.96121 4.60541C4.90314 4.74832 4.87384 4.90144 4.875 5.05588V15.9441C4.875 16.2554 4.99761 16.5538 5.21585 16.7739C5.42495 16.9848 5.70542 17.1071 6 17.117V17.9996C5.47332 17.9895 4.97033 17.7742 4.59714 17.3978C4.2148 17.0123 4 16.4894 4 15.9441V5.05588C4 4.51063 4.2148 3.98771 4.59714 3.60215C4.97948 3.2166 5.49804 3 6.03875 3H13.625Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1068 5.91602H8.89312C8.39103 5.91602 7.90951 6.11938 7.55448 6.48137C7.19945 6.84336 7 7.33433 7 7.84626V18.0691C7 18.581 7.19945 19.072 7.55448 19.434C7.90951 19.796 8.39103 19.9993 8.89312 19.9993H18.1068C18.6089 19.9993 19.0905 19.796 19.4455 19.434C19.8005 19.072 20 18.581 20 18.0691V7.84626C20 7.33433 19.8005 6.84336 19.4455 6.48137C19.0905 6.11938 18.6089 5.91602 18.1068 5.91602ZM19.1875 18.0691C19.1875 18.3613 19.0736 18.6416 18.871 18.8482C18.6683 19.0548 18.3934 19.1709 18.1068 19.1709H8.89312C8.60652 19.1709 8.33166 19.0548 8.129 18.8482C7.92635 18.6416 7.8125 18.3613 7.8125 18.0691V7.84626C7.81142 7.70126 7.83863 7.55749 7.89255 7.42331C7.94648 7.28914 8.02603 7.16723 8.12659 7.0647C8.22715 6.96217 8.34671 6.88105 8.47831 6.82607C8.6099 6.77109 8.75091 6.74334 8.89312 6.74445H18.1068C18.2491 6.74334 18.3901 6.77109 18.5217 6.82607C18.6532 6.88105 18.7728 6.96217 18.8734 7.0647C18.9739 7.16723 19.0535 7.28914 19.1074 7.42331C19.1613 7.55749 19.1885 7.70126 19.1875 7.84626V18.0691Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.8125,
    y: 9.64453,
    width: 11.375,
    height: 0.82843,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.0625,
    y: 9.64453,
    width: 0.812498,
    height: 9.94116,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.125,
    y: 9.64453,
    width: 0.812498,
    height: 9.94116,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.8125,
    y: 12.957,
    width: 11.375,
    height: 0.82843,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.8125,
    y: 16.2715,
    width: 11.375,
    height: 0.82843,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5577_21052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchemaView);
export default __webpack_public_path__ + "static/media/SchemaView.6a9f6606d884b543849940008478c985.svg";
export { ForwardRef as ReactComponent };